import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AdminOrderShipmentComponentGroup } from '../../models/admin-order-shipment-component-group';
import { AdminOrderComponentsListComponent } from '../admin-order-components-list/admin-order-components-list.component';

@Component({
  selector: 'app-admin-order-shipment-component-groups',
  imports: [AdminOrderComponentsListComponent],
  templateUrl: './admin-order-shipment-component-groups.component.html',
  styleUrl: './admin-order-shipment-component-groups.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminOrderShipmentComponentGroupsComponent {
  public readonly groups = input.required<AdminOrderShipmentComponentGroup[]>();
}
